type NavItemProps = {
  text: any
  href: any
  active: any
}

const NavItem = ({ text, href, active }: NavItemProps) => {
  return (
    <a href={href}>
      <p
        className={`nav__item ${
          active ? "active" : ""
        }`}
      >
        {text}
      </p>
    </a>
  );
};

export default NavItem;